export const PriceModel = () => {


    return (
        <div>
            pending
            {/* {prices && prices.length > 0 && conditions && <StockChart data={prices} conditions={conditions} />} */}
        </div>
    )
}